import { DuplicateFile } from '@dealstack/frontend/shared/components/Documents/types';
import { FileWithClassifier } from '@dealstack/frontend/shared/components/Documents/UploadDocuments/AddFileStep/types';
import { calculateMD5ForFile } from '@dealstack/frontend/shared/components/Documents/UploadDocuments/utils/calculateMD5ForFile';

/**
 * This will MD5 a file, then compare it to the rest of the files, if a duplicate is found it will
 * be pushed into a subRow and the total will be increased. Used for the duplicate modal file detection
 * Note this will return all files, with any duplicates as subFiles
 */
export const findDuplicateFiles = async (files: FileWithClassifier[], errorMessage: string) => {
	const md5Map = new Map<string, DuplicateFile>();
	const filesWithDuplicates: DuplicateFile[] = [];
	let totalDuplicates = 0;

	// Compute all MD5 hashes in parallel
	const md5Results = await Promise.all(
		files.map((file) => calculateMD5ForFile(file.file, errorMessage))
	);

	files.forEach((file, index) => {
		const md5 = md5Results[index];
		const existingEntry = md5Map.get(md5);

		if (existingEntry) {
			// This will mutate what's in duplicates, not great
			existingEntry.numberOfDuplicates = (existingEntry.numberOfDuplicates || 0) + 1;
			existingEntry.status = false;
			if (existingEntry?.subRows?.[0]) {
				existingEntry.subRows[0].isSelected = false;
			}

			existingEntry?.subRows?.push({
				index,
				file: file.file,
				md5,
				isSelected: false,
				classifierName: file.classifierName,
				dealClassifierId: file.dealClassifierId,
			});
			totalDuplicates += 1;
		} else {
			// Create a new entry if not already existing
			const newEntry: DuplicateFile = {
				index,
				file: file.file,
				md5,
				numberOfDuplicates: 0,
				classifierName: file.classifierName,
				dealClassifierId: file.dealClassifierId,
				subRows: [
					{
						index,
						file: file.file,
						md5,
						isSelected: true,
						classifierName: file.classifierName,
						dealClassifierId: file.dealClassifierId,
					},
				],
				status: true,
			};
			md5Map.set(md5, newEntry);
			filesWithDuplicates.push(newEntry);
		}
	});

	return {
		filesWithDuplicates,
		totalDuplicates,
	};
};
